import axios from 'axios';
import config from '../../assets/config.js';
import { createAsyncThunk } from '@reduxjs/toolkit';
import authHeader from './authHeader.js';

const backendURL = config.apiURL;
const base_url =window.location.origin+"/";

export const userProfile = createAsyncThunk(
    'user-profile',
    async (appUserID)=>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Auth/userprofile/${appUserID}`,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);

// https://v2dev-api.kogaruda.com/api/Auth/userprofile/30841